import { Component } from "@angular/core";
import { SelectWindow, ModalService } from "@xo/client-common";
import { Type8Timestamp, Type8TimestampType } from "./Type8Timestamp";

@Component({
    selector: "spec-app-type8-timestamp-select",
    templateUrl: "./type8Timestamp.select.html",
    styleUrls: ["./type8Timestamp.select.scss"]
})
export class Type8TimestampSelect extends SelectWindow<Type8Timestamp> {

    constructor(modalService: ModalService) {
        super(modalService, Type8TimestampType, "simpleField");
    }
}
